<template>
  <div class="ecommercedefenseproduct-page">
    <EcommerceDefenseProduct />
  </div>
</template>

<script>
import EcommerceDefenseProduct from '@/components/Infringements/Index.vue'
export default {
  components: {
    EcommerceDefenseProduct
  },
  data(){
    return{
      brandid: this.$route.params.Id,
      showreportbtn: true
    }
  },

}
</script>